import { R } from '@/caregiverSpace/resources/Texts.resx';

export const getAgeInYearsAndMonths = (dateString?: string | null): string => {
    if (!dateString) return '';

    const birthDate = new Date(dateString);
    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();

    if (today.getDate() < birthDate.getDate()) {
        months--;
    }

    if (months < 0) {
        years--;
        months += 12;
    }

    const yearPart = years == 1 ? `${years} ${R.Year}` : `${years} ${R.Years}`;
    const monthPart =
        months == 1 ? `${months} ${R.Month}` : `${months} ${R.Months}`;
    let returnValue;

    if (years < 1) {
        returnValue = monthPart;
    } else if (years < 3) {
        if (months == 0) {
            returnValue = yearPart;
        } else {
            returnValue = `${yearPart}, ${monthPart}`;
        }
    } else {
        returnValue = yearPart;
    }

    return returnValue;
};
